const duplicateElement = (htmlString, selector, numberOfDuplicates) => {
	// Create a temporary container to hold the HTML
	const container = document.createElement('div');
	container.innerHTML = htmlString;

	// Find the element by class name
	const element = container.querySelector(`${selector}`);
	if (element) {
		// Duplicate the element three times
		for (let i = 0; i < numberOfDuplicates; i++) {
			const clone = element.cloneNode(true);
			element.parentNode.insertBefore(clone, element.nextSibling);
		}
	}

	return container.innerHTML;
};

export default duplicateElement;
